import { render, staticRenderFns } from "./QuestForm.vue?vue&type=template&id=2c23c1e8&scoped=true&"
import script from "./QuestForm.vue?vue&type=script&lang=js&"
export * from "./QuestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23c1e8",
  null
  
)

export default component.exports